import { render } from "./ListePaiementPage.vue?vue&type=template&id=09646b24&ts=true"
import script from "./ListePaiementPage.vue?vue&type=script&lang=ts"
export * from "./ListePaiementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__